import { gql } from '@apollo/client';

export const ALL_ART_DRUGS = gql`
  query AllArtDrugs($input: AllArtDrugsInput!) {
    artDrugs: allArtDrugs(input: $input) {
      id
      name
      abbreviation
    }
  }
`;
